import { v4 as uuidv4 } from 'uuid';

/**
 * Generate a new conversation ID using UUID v4
 * Follows RFC 4122 standard for maximum compatibility
 */
export const generateConversationId = (): string => {
  return uuidv4();
};

/**
 * Validate if a string is a valid conversation ID
 * Basic validation for UUID format
 */
export const isValidConversationId = (id: string): boolean => {
  if (!id || typeof id !== 'string') return false;
  // UUID v4 format: 8-4-4-4-12 characters
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
};

/**
 * Check if this is a new conversation (empty or temporary ID)
 */
export const isNewConversation = (conversationId: string): boolean => {
  return !conversationId || conversationId === '';
};